import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyMonitoredIndividualList.css';
import SurveyResponsesSurveyMonitoredIndividualCard from './SurveyResponsesSurveyMonitoredIndividualCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import Pager from '../Pager/Pager';

const INDIVIDUALS_PER_PAGED_VIEW = 5;

export default function SurveyResponsesSurveyMonitoredIndividualList({ individuals, onSelect, fullWidth, selectedMonitoredIndividual }) {
  const [searchTerms, setSearchTerms] = useState('');
  const [visibleMonitoredIndividuals, setVisibleMonitoredIndividuals] = useState(individuals);
  const [currentPage, setCurrentPage] = useState(1);

  if (logComponent('SurveyResponsesSurveyMonitoredIndividualList')) { console.debug('SurveyResponsesSurveyMonitoredIndividualList rendered'); }


  useEffect(() => {
    if (logComponent('SurveyResponsesSurveyMonitoredIndividualList')) { console.debug('SurveyResponsesSurveyMonitoredIndividualList useEffect  [individuals, searchTerms]'); }
    updateVisibleMonitoredIndividuals();
  }, [individuals, searchTerms])


  const updateSearchTerms = (e) => {
    if (logComponent('SurveyResponsesSurveyMonitoredIndividualList')) { console.debug('SurveyResponsesSurveyMonitoredIndividualList updateSearchTerms'); }
    setSearchTerms(e.target.value);
  }


  const updateVisibleMonitoredIndividuals = () => {
    if (logComponent('SurveyResponsesSurveyMonitoredIndividualList')) { console.debug('SurveyResponsesSurveyMonitoredIndividualList updateVisibleMonitoredIndividuals'); }

    let filteredMonitoredIndividuals = individuals.filter(collection => {

      return collection.lastName.toLowerCase().includes(searchTerms.toLowerCase()) ||
        collection.legalFirstName.toLowerCase().includes(searchTerms.toLowerCase()) ||
        (collection.preferredFirstName && collection.preferredFirstName.toLowerCase().includes(searchTerms.toLowerCase())) ||
        collection.lastKnownFacilityName.toLowerCase().includes(searchTerms.toLowerCase()) ||
        collection.activeUnitName.toLowerCase().includes(searchTerms.toLowerCase()) 
        ;
    });

    setVisibleMonitoredIndividuals(filteredMonitoredIndividuals);
  }

  const updateSelectedMonitoredIndividual = (monitoredIndividual) => {
    if (logComponent('SurveyResponsesSurveyMonitoredIndividualList')) { console.debug('SurveyResponsesSurveyMonitoredIndividualList updateSelectedMonitoredIndividual'); }
    onSelect(monitoredIndividual);
  }

  const selectPage = (surveyPage) => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList selectSurveyPage'); }
    if (visibleMonitoredIndividuals && visibleMonitoredIndividuals.length > 0) {
      let newSelectedMonitoredIndividuals = visibleMonitoredIndividuals.slice((surveyPage - 1) * INDIVIDUALS_PER_PAGED_VIEW, surveyPage * INDIVIDUALS_PER_PAGED_VIEW)[0];
      onSelect(newSelectedMonitoredIndividuals);

    }
    setCurrentPage(surveyPage);
  }

  return (
    visibleMonitoredIndividuals &&
    <div className={'Survey-Response-Survey-Monitored-Individual-List' + (fullWidth ? ' Survey-Response-Survey-Monitored-Individual-List--full-width' : '')}>
      <div className="Survey-Response-Survey-Monitored-Individual-List__search-wrapper">
        <FontAwesomeIcon icon="search" className="Survey-Response-Survey-Monitored-Individual-List__search-icon" />
        <input
          type="text"
          className="Survey-Response-Survey-Monitored-Individual-List__search-input"
          placeholder="Search individuals"
          value={searchTerms}
          onChange={updateSearchTerms} />
      </div>
        <div className="Survey-Response-Survey-Monitored-Individual-List__pager">
          <Pager
            items={visibleMonitoredIndividuals.length}
            onChange={selectPage}
            selectedPage={currentPage}
            pageSize={INDIVIDUALS_PER_PAGED_VIEW}
          />
        </div>
      <ul className="Survey-Response-Survey-Monitored-Individual-List__individuals">
        {
            visibleMonitoredIndividuals
              .slice((currentPage - 1) * INDIVIDUALS_PER_PAGED_VIEW, currentPage * INDIVIDUALS_PER_PAGED_VIEW)
              .map(monitoredIndividual =>
            <SurveyResponsesSurveyMonitoredIndividualCard
              key={monitoredIndividual.monitoredIndividualId}
              monitoredIndividual={monitoredIndividual}
              onClick={updateSelectedMonitoredIndividual}
              selected={!fullWidth && selectedMonitoredIndividual ? monitoredIndividual.monitoredIndividualId === selectedMonitoredIndividual.monitoredIndividualId : false} />
          )
        }
      </ul>
      {
        visibleMonitoredIndividuals &&
        visibleMonitoredIndividuals.length === 0 &&
        <p className="Survey-Response-Survey-Monitored-Individual-List__empty-message">No individuals found...</p>
      }
    </div>
  );
}